import { useContext } from "react";
import { isEmpty } from "lodash";
import { PermissionsContext } from "src/utils/Permissions/PermissionsContext";
import { IPermission } from "src/utils/Permissions/permissions.models";

/**
 * Custom hook for checking HRTools-related permissions
 * @param permission Permission constant from RoleBasedSecurity/permissions.js
 * @returns boolean indicating if the user has the specified permission
 */
export const usePermission = (permission: string): boolean => {
  const { permissions } = useContext(PermissionsContext);

  if (!permissions || isEmpty(permissions)) return false;

  return permissions.some(
    (permissionObj: IPermission) => permissionObj.objectId === permission
  );
};
